const NAMESPACE = "envelopeStatus";

const KEYS = {
    statusHeader: "statusHeader",
    itemsHeader: "itemsHeader",
    savedDocumentsHeader: "savedDocumentsHeader",
    recipientsHeader: "recipientsHeader"
};

const MESSAGES = {
    [KEYS.statusHeader]: {
        value: "Status",
        comment: "Header for the Status section of the page."
    },
    [KEYS.itemsHeader]: {
        value: "Items",
        comment: "Header for the Items section of the page."
    },
    [KEYS.savedDocumentsHeader]: {
        value: "Saved Documents",
        comment: "Header for the Saved Documents section of the page."
    },
    [KEYS.recipientsHeader]: {
        value: "Recipients",
        comment: "Header for the Recipients section of the page."
    }
};

export { KEYS, NAMESPACE, MESSAGES };
